export const apiEndpoint = {
  bcrm_platform: process.env.VUE_APP_ENDPOINT_BCRM_PLATFORM, 
};
